import toastMessage from "../../utils/toastMessage";
import language from "../../language";
import formatDropdownData from "../../utils/formatDropdownData";
import axios from "axios";
import { getStorage } from "../../utils/storage";
import api from "../../utils/api";

export const fetchMerchantID = async (lng = "english", params) => {
  const { listType } = params || {};
  const { accessToken } = await getStorage();

  if (!accessToken) return;

  let headers = {
    "Content-Type": "application/json;charset=UTF-8",
    authorization: "Bearer " + accessToken,
  };

  try {
    const options = {
      method: "GET",
      url: `${api("profile")}/identifier`,
      data: null, //force axios send headers content type
      headers,
    };

    const data = await axios(options);

    if (listType === "dropdown") {
      return formatDropdownData(data.data, "name", "id");
    }

    let results = data.data;

    return results;
  } catch (error) {
    toastMessage("error", language[lng].unable_to_fetch_merchant_id);
  }
};
